import { useField } from 'formik';
import React from 'react';
import { isReadOnly } from 'utilities/JSUtil';
import './SelectInput.scss';

const SelectInput = ({ label, ...props }) => {
    const [field, meta, helpers] = useField(props);

    let classes = 'form-input-value'

    let requiredLabel = undefined
    let error = undefined

    if (props.isrequired === 'true') {
        requiredLabel = '*'
    } else if (props.isdependent === 'true') {
        requiredLabel = '**'
    }

    if (meta.error) {
        error = <div className='invalid'>{meta.error}</div>
    }

    let properties = { ...props }
    delete properties['options']

    return (
        <div id={props.id} className='form-input'>
            {label && <label htmlFor={props.name} className='form-input-label'>
                {label}{requiredLabel}
            </label>
            }
            <div className={classes}>
                <select {...field} {...properties} title={properties.title || label} disabled={props.overridedisabledflag === 'true' ? false : (isReadOnly() || props.disabled)}>
                    <option value="" style={{ display: 'none' }}></option>
                    {props.options?.map((entry) => {
                        return <option key={'option-' + entry.value} value={entry.title || entry.value} title={entry.label}>{entry.label}</option>
                    })}
                </select>
                {error}
            </div>
        </div>
    );
};

export default SelectInput
